var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5832 2.29199H6.37573C3.86323 2.29199 2.28906 4.07033 2.28906 6.58699V13.3778C2.28906 15.8945 3.85656 17.6728 6.37573 17.6728H13.5824C16.1024 17.6728 17.6699 15.8945 17.6699 13.3778V6.58699C17.6699 4.07033 16.1024 2.29199 13.5832 2.29199Z",
    stroke: "#314064",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91958 7.32154C8.91958 8.1707 8.23042 8.85987 7.38125 8.85987C6.53292 8.85987 5.84375 8.1707 5.84375 7.32154C5.84375 6.47237 6.53292 5.7832 7.38125 5.7832C8.23042 5.7832 8.91958 6.47237 8.91958 7.32154Z",
    stroke: "#314064",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6725 12.459C16.8442 11.7382 16.1233 10.8707 15.1733 10.2982C14.2217 9.72569 13.1992 10.079 12.5392 10.9332C11.9017 11.759 11.5033 12.8699 10.5408 13.3907C9.355 14.0332 8.65833 12.9974 7.66917 12.5824C6.565 12.1199 5.72667 12.9515 5.08167 13.7507C4.43583 14.5507 3.78167 15.3424 3.125 16.134",
    stroke: "#314064",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/imageIcon.23e1270df2f9983247d39f8ddd5648da.svg";
export { ForwardRef as ReactComponent };